export class HttpApiRequestOptions {
  preventSpinner?: boolean = false;
  preventErrorHandler?: boolean = false;
  progressCallback?: (progress: number) => void;
}
